import React, { useState } from "react";
import { Alert, ProgressBar } from "react-bootstrap";

const FormAlert = ({ errors, dismissible, isLoading }) => {
  const [show, setShow] = useState(true);

  if (!errors && !isLoading) {
    return null;
  }

  if (isLoading) {
    return (
      <>
        <ProgressBar animated now={100} />
        <br />
      </>
    );
  }

  const formStatusErrors = [];

  Object.keys(errors).forEach((key) => {
    if (key === "message" || !Number.isNaN(key)) formStatusErrors.push(errors[key]);
  });

  if (!formStatusErrors.length) return null;

  return (
    errors && (
      <Alert show={show} variant="danger" dismissible={dismissible} onClose={() => setShow(false)}>
        <ul>
          {formStatusErrors.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </Alert>
    )
  );
};

export default FormAlert;
